import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../primeng/modal/modal.component';
import { TourService } from '../../../services/tour.service';
import { isDelegatePanelLabel } from '../../../services/tour-steps.util';

@Component({
  selector: 'app-tour-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './tour-modal.component.html',
  styleUrl: './tour-modal.component.scss',
})
export class TourModalComponent {
  readonly tour = inject(TourService);

  get isDelegatePanel(): boolean {
    return isDelegatePanelLabel(this.tour.panelLabel());
  }

  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.tour.close();
    }
  }
}
